export const plans = [
	{
		title: 'Book Exhibition',
		desc: 'Special discounts on the best books every Friday!',
		author: 'BookOn Team',
		date: '30 minutes ago',
		location: 'Tashkent, Uzbekistan',
		img: '/img/discount.webp',
	},
	{
		title: 'New Books',
		desc: 'New books are coming on Monday!',
		author: 'BookOn Editor',
		date: '2 days ago',
		location: 'Tashkent, Uzbekistan',
		img: '/img/fresh.webp',
	},
	{
		title: 'Authors Meetup',
		desc: 'Meet your favorite authors and get your books signed',
		author: 'BookOn Events',
		date: '5 days ago',
		location: 'Tashkent, Uzbekistan',
		img: '/img/coming.webp',
	},
	{
		title: 'Follow Us on Social Media',
		desc: '📚 We share useful information about books on social media',
		author: 'BookOn Media',
		date: 'A week ago',
		location: 'Tashkent, Uzbekistan',
		img: '/img/food-city.webp',
	},
];
